// extracted by mini-css-extract-plugin
export default {"cards-4":"Offering_cards-4__kmyWU","card":"Offering_card__dEf3d","btn-link":"Offering_btn-link__2dN3x"};